module.exports = __webpack_public_path__ + "static/media/quote.37cb2a3e.svg";